/**
 * ==========================================================================================
 * ! DO NOT EXPOSE ANYTHING FROM UNDER THIS FOLDER TO THE CLIENT !
 * ! OTHER THAN THROUGH THE ADMIN CHUNK AS IT REQUIRES AUTHORIZATION TO ACCESS !
 * ==========================================================================================
 */
import { ComponentType } from 'react';
import Loadable, { LoadableComponent } from 'react-loadable';
import { useSelector } from 'react-redux';
import { selectIsValidated } from 'store/appShell/selector';

function withAuth<Props extends object>(Component: ComponentType<Props> & LoadableComponent) {
  return (props: Props) => {
    const isAdmin = useSelector(selectIsValidated);

    return isAdmin ? <Component {...props} /> : null;
  };
}

export const AdminCheckoutProductRow = withAuth(
  Loadable({
    loader: () => import(/* webpackChunkName: "admin" */ './checkout/adminCheckoutProductRow'),
    loading: () => null
  })
);

export const AdminHeader = withAuth(
  Loadable({
    loader: () => import(/* webpackChunkName: "admin" */ './header/header'),
    loading: () => null
  })
);

export const AdminMenu = withAuth(
  Loadable({
    loader: () => import(/* webpackChunkName: "admin" */ './menu/adminMenu'),
    loading: () => null
  })
);

export const AdminCheckoutCharges = withAuth(
  Loadable({
    loader: () => import(/* webpackChunkName: "admin" */ './charges/adminCheckoutCharges'),
    loading: () => null
  })
);
